import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Calendar, GraduationCap, Mail, Phone, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';
import { importedSiteImages, mentorshipCopy } from '@/content/public-site-content';

export default function MentorshipPage() {
  return (
    <div className="mx-auto w-full max-w-6xl space-y-8 px-4 py-6 sm:px-6 lg:px-8 lg:py-10">
      <section className="overflow-hidden rounded-[2rem] border border-border/70 bg-card shadow-sm">
        <div className="grid gap-0 lg:grid-cols-[1fr_0.95fr]">
          <div className="space-y-5 p-8 sm:p-10">
            <Badge variant="outline" className="w-fit border-primary/30 bg-primary/5">
              <GraduationCap className="mr-1 h-3 w-3 text-primary" />
              {mentorshipCopy.title}
            </Badge>
            <h1 className="text-3xl font-bold tracking-tight sm:text-4xl">
              {mentorshipCopy.title}
            </h1>
            <p className="text-base leading-7 text-muted-foreground sm:text-lg">
              {mentorshipCopy.description}
            </p>
            <div className="flex flex-wrap gap-3">
              <Button asChild>
                <Link to="/auth/register">Register</Link>
              </Button>
              <Button variant="outline" asChild>
                <Link to="/signin">Log into account</Link>
              </Button>
            </div>
          </div>
          <div className="relative min-h-[320px] bg-muted">
            <img
              src={importedSiteImages.mentorshipHero}
              alt="Global Leadership Forum"
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background/60 via-transparent to-transparent" />
          </div>
        </div>
      </section>

      <section className="grid gap-6 lg:grid-cols-[1.1fr_0.9fr]">
        <Card className="border-primary/20 bg-primary/5">
          <CardContent className="space-y-6 p-8">
            <div className="flex items-center gap-3">
              <Sparkles className="h-5 w-5 text-primary" />
              <h2 className="text-2xl font-semibold">Join the mentorship program today</h2>
            </div>
            <div className="space-y-4">
              {mentorshipCopy.steps.map((step, index) => (
                <div key={step} className="flex gap-4 rounded-2xl border border-primary/10 bg-background/70 p-4">
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary text-sm font-semibold text-primary-foreground">
                    {index + 1}
                  </div>
                  <p className="text-sm leading-6 text-muted-foreground">{step}</p>
                </div>
              ))}
            </div>
            <div className="flex flex-wrap gap-3">
              <Button asChild>
                <Link to="/auth/register">Register</Link>
              </Button>
              <Button variant="outline" asChild>
                <Link to="/dashboard">Go to account dashboard</Link>
              </Button>
            </div>
          </CardContent>
        </Card>

        <Card className="border-border/70 bg-card/90">
          <CardContent className="space-y-5 p-8">
            <div className="flex items-center gap-3">
              <Calendar className="h-5 w-5 text-primary" />
              <h2 className="text-xl font-semibold">For more information</h2>
            </div>
            <div className="space-y-3 text-sm text-muted-foreground">
              <a href={`mailto:${mentorshipCopy.supportEmail}`} className="flex items-center gap-3 hover:text-foreground">
                <Mail className="h-4 w-4 text-primary" />
                {mentorshipCopy.supportEmail}
              </a>
              {mentorshipCopy.supportPhones.map((phone) => (
                <a key={phone} href={`tel:${phone}`} className="flex items-center gap-3 hover:text-foreground">
                  <Phone className="h-4 w-4 text-primary" />
                  {phone}
                </a>
              ))}
            </div>
          </CardContent>
        </Card>
      </section>
    </div>
  );
}
